import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'
import {useFilterByLicense} from '@/biz/license.jsx'

export default function MenuButtonAiGenCode(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const handleClick = () => map.commands.aiGenerateCode(map.selectedNodes)

    return filterByLicense('M00040003',
        <MenuButton
            onClick={handleClick}
            {...props}
        >
            AI编写程序
        </MenuButton>
    )
}
